import { render, staticRenderFns } from "./IconHyzbjb.vue?vue&type=template&id=79a927a9"
import script from "./IconHyzbjb.vue?vue&type=script&lang=js"
export * from "./IconHyzbjb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports